import { render, staticRenderFns } from "./eventExhibition.vue?vue&type=template&id=44bfccac&scoped=true"
import script from "./eventExhibition.vue?vue&type=script&lang=js"
export * from "./eventExhibition.vue?vue&type=script&lang=js"
import style0 from "./eventExhibition.vue?vue&type=style&index=0&id=44bfccac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bfccac",
  null
  
)

export default component.exports